import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TestimonialPopup from "../../../Common/Popups/TestimonialPopup";
import LeadGen from "../../../Common/Popups/LeadGen";
import { increaseViewCount } from "../../../Common/CommonMethods";
import ImageLoader from "../../../Common/ImageLoader";

const TestimonialBox = (props) => {
  const [isLeadGenPopUp, setLeadGenPopUp] = useState(false);
  const [isEntered, setIsEntered] = useState(false);
  const [vendorTestimonial, setVendorTestimonial] = useState({
    activeVideoPopUp: {
      isPopUpActive: false,
    },
    ...props,
  });
  const setPopUpFalse = (location) => {
    const tempObj = {
      ...vendorTestimonial,
      ...location,
      activeVideoPopUp: {
        isPopUpActive: false,
      },
    };
    setVendorTestimonial(tempObj);
    setIsEntered(false);
  };

  const postLeadRegPopUp = () => {
    setVendorTestimonial({
      ...vendorTestimonial,
      activeVideoPopUp: {
        isPopUpActive: true,
      },
      toLocation: props.pathname,
    });
  };

  return (
    <React.Fragment>
      <li
        onClick={(e) => {
          e.preventDefault();
          if (props.location.pathname.includes("/premium/preview")) {
            return;
          }
          setIsEntered(false);
          if (props.isLeadGenPopUp) {
            setLeadGenPopUp(true);
          } else {
            if (!props.isEnterpriseLogin) {
              increaseViewCount(
                process.env.REACT_APP_API_URL,
                "ct",
                vendorTestimonial.id
              );
              setVendorTestimonial({
                ...vendorTestimonial,
                activeVideoPopUp: {
                  isPopUpActive: true,
                },
                toLocation: props.pathname,
              });
            }
          }
        }}
      >
        <div className="logo">
          <img
            src={vendorTestimonial.customer_logo || props.logo}
            alt=""
            title={vendorTestimonial.customer_name}
            width={150}
            height={45}
          />
        </div>
        <p>{vendorTestimonial.body}</p>
        {!!vendorTestimonial &&
          !!vendorTestimonial?.contactdetail &&
          !!Object.keys(vendorTestimonial.contactdetail).length && (
            <div className="footer_bottom">
              <div className="user_details">
                <span className="name">
                  {vendorTestimonial.contactdetail.name}
                </span>
                <span className="desgn">
                  {vendorTestimonial.contactdetail.jobtitle}
                </span>
              </div>
            </div>
          )}
        {vendorTestimonial.activeVideoPopUp &&
        vendorTestimonial.activeVideoPopUp.isPopUpActive ? (
          <TestimonialPopup
            testimonialDataForPopUp={vendorTestimonial}
            isDataFromProps={true}
            setPopUpFalse={setPopUpFalse}
          />
        ) : null}
        {isLeadGenPopUp ? (
          <LeadGen
            {...props}
            setLeadGenPopUp={setLeadGenPopUp}
            postLeadRegPopUp={postLeadRegPopUp}
            pathname={props.pathname.replace("/testimonials", "")}
            linkedInUrl={props.linkedInUrl}
          />
        ) : null}
      </li>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isEnterpriseLogin: state.homePage.isEnterpriseLogin,
  };
};

const TestimonialBoxRouter = withRouter(TestimonialBox);

export default connect(mapStateToProps)(TestimonialBoxRouter);
